import React, { Component } from "react";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as enrolGIRONowSelector from "../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../common/actions/enrolGIRONow";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import CustomBoardGiro from "../../components/CustomBoardGiro";
import CustomEnrolGiroNowV2 from "../../components/CustomEnrolGiroNowV2";
import LoadingOverlay from "../../components/LoadingOverlay";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";

const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      isOnClickNext: false,
      error: false,
      errorMsg: "",
      localDDARef: "",
      localBankTransId: "",
      localGiroIntervalTime: "",
      localRetryCount: "",
      testAction: false,
      localBackToPolicy: "",
      localGiroFlow: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    //console.log("?")
    window.addEventListener("resize", this.updateWindowDimensions);
    // localStorage.setItem("EnrolGiroFooter", "true");
    // var ddaRefNo = this.getUrlVars()["DDARefNo"];
    // var bankTransId = this.getUrlVars()["BankTransId"];
    // var giroIntervalTime = this.getUrlVars()["GiroIntervalTime"];
    // var giroRetryCount = this.getUrlVars()["GiroRetryCount"];
    // var backToPolicy = this.getUrlVars()["BackToPolicy"];
    // var giroFlow = this.getUrlVars()["GiroFlow"];
    // window.localStorage.setItem("GiroFlow",giroFlow)
    // this.setState({
    //   localDDARef: ddaRefNo,
    //   localBankTransId: bankTransId,
    //   localGiroIntervalTime: giroIntervalTime,
    //   localRetryCount: giroRetryCount,
    //   localBackToPolicy:backToPolicy,
    //   localGiroFlow:giroFlow
    // });
  }

  componentDidUpdate = (prevProps, prevState) => {
    // const {
    //   localDDARef,
    //   localBankTransId,
    //   testAction,
    //   localRetryCount,
    //   localGiroIntervalTime,
    //   localBackToPolicy,
    // } = this.state;
    // const { getGiroCallBackExist } = this.props;
    // const data = enrolGIRONowSelector.getGiroCallBackExistDataData(
    //   this.props.getGiroCallBackExistData
    // );
    // const status = enrolGIRONowSelector.getGiroCallBackDataStatusStatus(data);
    // const redirectUrl = enrolGIRONowSelector.getGiroCallBackDataRedirectUrl(
    //   data
    // );
    // if (localDDARef !== "" && localBankTransId !== "") {
    //   if (testAction === false) {
    //     getGiroCallBackExist(localDDARef, localBankTransId);
    //     this.setState({ testAction: true });
    //   }
    // }
    // if (
    //   prevProps.getGiroCallBackExistData !== this.props.getGiroCallBackExistData
    // ) {
    //   if (
    //     parseInt(localRetryCount) > 0
    //   ) {
    //     this.setState({ localRetryCount: parseInt(localRetryCount) - 1 });
    //     if (status === false) {
    //       setTimeout(function () {
    //         getGiroCallBackExist(localDDARef, localBankTransId);
    //       }, parseInt(localGiroIntervalTime));
    //     } else {
    //       if(localBackToPolicy === "true"){
    //         let a = redirectUrl.substring(redirectUrl.indexOf("=") + 1);
    //         console.log("a",a);
    //         window.location.href =  process.env.REACT_APP_TIQ_BASE_POLICY_URL + "?id=" + a ;
    //       }else if (localBackToPolicy === "trueILP"){
    //         let a = redirectUrl.substring(redirectUrl.indexOf("=") + 1);
    //         window.location.href =  process.env.REACT_APP_TIQ_BASE_ILP_POLICY_URL + "?id=" + a ;
    //       }else if (localBackToPolicy === "trueRPILP"){
    //         let a = redirectUrl.substring(redirectUrl.indexOf("=") + 1);
    //         window.location.href =  process.env.REACT_APP_TIQ_BASE_RPILP_POLICY_URL + "?id=" + a ;
    //       }else{
    //         window.location.href = redirectUrl;
    //       }
    //     }
    //   } else {
    //     if(this.state.localGiroFlow === "2"){
    //       if(window.localStorage.getItem("MyToken")){
    //         window.location.href = process.env.REACT_APP_TIQ_BASE_URL + `/#/PaymentResult`;
    //       }else{
    //         this.props.history.push("/PaymentStatus");
    //       }
    //       return;
    //     }
    //     this.props.history.push("/GiroStatus?status=fail");
    //   }
    // }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangePolicyNo = (event) => {
    this.setState({ policyNo: event.target.value });
  };

  onClickBack = () => {
    window.history.back();
  };

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error } = this.state;
    return (
      <Grid style={{display:"Flex",flexDirection:"column",alignSelf:"center"}}>
        {/* <LoadingOverlay loading={true} /> */}
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <img src={Image.successfulLogin} style={{width:"5vw",height:"10vh"}}/>
        </Grid>
        <Grid style={{marginTop:"10px"}}>
          {" "}
          <CustomText style={{fontWeight:"bold",fontSize:"18px",textAlign:"center"}}>
          Signing process has been successfully completed.
          </CustomText>
        </Grid>
        {/* <CustomButton style={{textTransform:"none",width:"10vw",alignItems:"center",alignSelf:"center",marginTop:"10px"}} onClick={()=>this.props.history.push("/")}>
          Back to login
        </CustomButton> */}
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Nomination of beneficiaries</title>
        </Helmet>
        {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}

        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={height}
            width={width}
          />
        ) : (
          false
        )}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 ? this.renderChildren() : false}

        {this.props.getDDAPolicyLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "100vh",
    minHeight: "100vh",
    // backgroundImage:
    //   window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    // backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    // backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    // backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: `${screenW} ${screenH}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  ImageStyle:{
    width: "20px",
    height: 20,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
    fontSize: "16px",
    color: "#424143",
    fontFamily: "Muli",
  },
  textInputContainer: {
    height: 45,
    marginTop: 7,
  },
  nextButtonStyle: {
    //width: 150,
    marginTop: 10,
    marginBottom: 10,
    height: 40,
    fontFamily: "Muli",
    fontSize: "18px",
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 30,
  },
  renewNowTextStyleV2: {
    ...getFontWeight("400"),
    fontSize: 17,
    textAlign: "center",
    fontFamily: "Muli",
    marginBottom: 45,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "30%",
    marginRight: window.innerWidth < 601 ? false : "30%",
  },
});

function mapStateToProps(state) {
  return {
    getGiroCallBackExistData: selector.getGiroCallBackExistData(state),
    getGiroCallBackExistLoading: selector.getGiroCallBackExistLoading(state),
    getGiroCallBackExistStatus: selector.getGiroCallBackExistStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getGiroCallBackExist: (ddaRefNo, bankTransId) =>
      dispatch(
        enrolGIRONowAction.getGiroCallBackExistData(ddaRefNo, bankTransId)
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(LandingPage)));
